import { Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { Status as StatusEnum } from "../../model/box_status";

export function StatusIcon({ label, status }) {
  const colorTheme = status === StatusEnum.ONLINE ? "success" : status === StatusEnum.OFFLINE ? "error" : "unknown";
  const icon =
    status === StatusEnum.ONLINE ? <CheckCircleIcon fontSize="small" /> : <ErrorIcon fontSize="small" color="white" />;

  return <Chip variant="outlined" label={label} icon={icon} size="small" color={colorTheme} />;
}
